module.exports = __webpack_public_path__ + "static/media/017-girl-2.24118a61.svg";